import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { isEqual } from 'lodash-es';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SearchActions } from './search.actions';
import { SearchSelectors } from './search.selectors';

export const maxListLength = 10;

@Injectable()
export class SearchEffects {
  addToListSearch$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(SearchActions.AddToListSearch),
      concatLatestFrom(() => this.store.select(SearchSelectors.getState())),
      map(([action, state]) => {
        state.searchList = state.searchList.filter(
          (search) => !isEqual(search.searchParams, action.payload.searchParams)
        );

        const newState = {
          ...state,
          // Cap list to 10 entries
          searchList:
            state.searchList.length >= maxListLength
              ? [action.payload, ...state.searchList.slice(0, maxListLength - 1)]
              : [action.payload, ...state.searchList],
        };

        localStorage.setItem('searchHistoryList', JSON.stringify(newState.searchList));

        return SearchActions.ListSearchSuccess({ payload: newState });
      })
    );
  });

  constructor(private actions$: Actions, private store: Store) {}
}
